import React from "react";
import { ApiUrl } from "../../config/apiConfig";
import EditableTextPage from "./EditableTextPage";

const TermsConditions: React.FC = () => {
  return (
    <EditableTextPage
      title="Terms & Conditions"
      fetchUrl={ApiUrl.listTermsAndCondtion}
      updateUrl={ApiUrl.addEditTermsAndCondtion}
    />
  );
};

export default TermsConditions;
